const top = () => {
  if (window.pageYOffset !== undefined) {
    return window.pageYOffset;
  }

  return (document.documentElement
        || document.body.parentNode
        || document.body)
    .scrollTop;
};

const scrollWindow = (scrollThreshold, desktopInfoBar) => {
  if (top() >= scrollThreshold) {
    if (desktopInfoBar) {
      window.scrollBy({ left: 0, top: -243, behavior: 'smooth' });
    } else {
      window.scrollBy({ left: 0, top: -70, behavior: 'smooth' });
    }
  }
};

const anchorOffset = (scrollThreshold, desktopInfoBar) => {
  window.onload = () => {
    if (window.location.href.includes('#page-section-')) {
      scrollWindow(scrollThreshold, desktopInfoBar);
    }
  };

  const pageSections = document.querySelectorAll('.dropdown__page-section');

  pageSections.forEach((pageSection) => {
    pageSection.addEventListener('click', () => {
      // hack to fix navigation scroll to correct anchor
      const fixAnchorNavigation = () => {
        scrollWindow(scrollThreshold, desktopInfoBar);
      };
      setTimeout(fixAnchorNavigation, 800);
    });
  });
};

export default anchorOffset;
